const PROCEDURE_STANDALONE_MODE = "standalone"

export default {
  PROCEDURE_STANDALONE_MODE : PROCEDURE_STANDALONE_MODE
}
